// dev
// export const API_URL = 'http://localhost:3001';
// export const API_URL = 'https://api.roulette.wow.sbox.site';
// export const SOCKET_URL = 'https://roulette.wow.sbox.site'; // 'https://sky.sbox.site';
// export const MAC_ADDR_URL = 'http://localhost:3002';

// export const API_URL = 'https://api.roulette.tt.wow.sbox.site';
// export const SOCKET_URL = 'https://roulette.tt.wow.sbox.site';

// prod

// export const API_URL = 'https://api.roulette.betcabana.backoffice.ltd';
// export const API_URL = 'http://localhost:3001';
// export const SOCKET_URL = 'https://roulette.betcabana.backoffice.ltd';
// export const MAC_ADDR_URL = 'http://localhost:3002';



// export const SOCKET_URL = 'https://roulette.tt.wow.sbox.site';


// export const SOCKET_URL = 'https://roulette.tt.wow.sbox.site'; // DOUBLE ZERO
// SINGLE ZERO // 'https://roulette.betcabana.backoffice.ltd';

// export const API_URL = 'https://api.roulette.wow.sbox.site';


// export const API_URL = 'http://localhost:3001';
// export const SOCKET_URL = 'https://roulette.wow.sbox.site';

const { protocol, hostname } = window.location;
export const API_URL = `${protocol}//api.roulette.${hostname}`;
export const SOCKET_URL = `${protocol}//roulette.${hostname}/`;
export const MAC_ADDR_URL = 'http://localhost:3002';

